import React, { useEffect, useState } from "react";
import CommonService from "../../services/common.service";
import { Link } from "react-router-dom";

const GuestCommonheader = (props) => {
  const [accountDetails, setAccountDetails] = useState({});
  const userDetails = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    if (props.accountName) {
      CommonService.userAllGame(props.accountName).then((res) => {
        if (res.status === 200) {
          setAccountDetails(res.accountDetails);
        }
      });
    }
  }, []);
  return (
    <>
      <div className="banner-section">
        <div className="banner-content">
          <div className="left-section">
            <figure>
              <img
                src={`${process.env.REACT_APP_CLUB_PROFILE}${accountDetails?.club_logo}`}
                alt="mct_image"
              />
            </figure>
            <div className="gamebar_detail">
              <h2>{accountDetails?.club_name}</h2>
              {userDetails && (
                <ul className="game-btn">
                  <li>
                    <Link to={`/my-games`}>My Games</Link>
                  </li>
                </ul>
              )}
              {!userDetails && (
                <ul className="game-btn">
                  <li>
                    {" "}
                    <Link
                      to={`/account-hub?account_name=${props.accountName}`}
                      className=""
                    >
                      <i className="fas fa-home"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/member-signup?account_name=${props.accountName}`}
                    >
                      Sign-Up
                    </Link>
                  </li>
                  <li>
                    <Link to={`/login`}>Login</Link>
                  </li>
                  <li className="nav-item">
                    <div className="dropdown ">
                      <Link
                        className="dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fas fa-bars"></i>
                      </Link>
                      <ul
                        className="dropdown-menu mobiledropdownmenu logindropdown"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <Link
                            className="dropdown-item custom_dd_class"
                            to="/how-to-play"
                          >
                            How To Play
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"/rules"}
                            className="dropdown-item custom_dd_class"
                          >
                            Rules
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item custom_dd_class"
                            to="/faqs"
                          >
                            FAQs
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuestCommonheader;
